<template>
  <FormBase :busy="busy" @submit="save">
    <template #title>Customer Info: </template>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">First Name</label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.first_name"
          type="text"
          class="form-control "
          :class="{ 'is-invalid': hasError('first_name') }"
          @input="clearError('first_name')"
        />
        <div v-if="hasError('first_name')" class="invalid-feedback">
          {{ getError("first_name") }}
        </div>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">Last Name</label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.last_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': hasError('last_name') }"
          @input="clearError('last_name')"
        />
        <div v-if="hasError('last_name')" class="invalid-feedback">
          {{ getError("last_name") }}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-3 col-lg-3 col-form-label">Company Name</label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.company_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': hasError('company_name') }"
          @input="clearError('company_name')"
        />
        <div v-if="hasError('company_name')" class="invalid-feedback">
          {{ getError("company_name") }}
        </div>
        <span class="form-text text-muted">
          If you want your invoices addressed to a company. Leave blank to use
          your full name.
        </span>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Contact Phone
      </label>
      <div class="col-lg-9 col-xl-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="la la-phone"></i>
            </span>
          </div>
          <input
            v-model="form.phone"
            type="text"
            placeholder="Phone"
            aria-describedby="basic-addon1"
            class="form-control"
            :class="{ 'is-invalid': hasError('phone') }"
            @input="clearError('phone')"
          />
          <div v-if="hasError('phone')" class="invalid-feedback">
            {{ getError("phone") }}
          </div>
        </div>
        <span class="form-text text-muted">
          We'll never share your phone number with anyone else.
        </span>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Email Address
      </label>
      <div class="col-lg-9 col-xl-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="la la-at"></i></span>
          </div>
          <input
            v-model="form.email"
            type="text"
            placeholder="Email"
            aria-describedby="basic-addon1"
            class="form-control"
            :class="{ 'is-invalid': hasError('email') }"
            @input="clearError('email')"
          />
          <div v-if="hasError('email')" class="invalid-feedback">
            {{ getError("email") }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Alternative Email
      </label>
      <div class="col-lg-9 col-xl-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="la la-at"></i></span>
          </div>
          <input
            v-model="form.alternate_email"
            type="text"
            placeholder="Email"
            aria-describedby="basic-addon1"
            class="form-control"
            :class="{ 'is-invalid': hasError('alternate_email') }"
            @input="clearError('alternate_email')"
          />
          <div v-if="hasError('alternate_email')" class="invalid-feedback">
            {{ getError("alternate_email") }}
          </div>
        </div>
      </div>
    </div>
  </FormBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FormBase from "./-FormBase.vue";
import ValidationErrorsMixin from "@/mixins/ValidationErrors.js";

export default {
  name: "ProfileForm",
  components: {
    FormBase,
  },

  mixins: [ValidationErrorsMixin],

  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },

  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        company_name: "",
        phone: "",
        email: "",
        alternate_email: "",
      },
      busy: false,
    };
  },

  mounted() {
    this.form = {
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      company_name: this.user.company_name,
      phone: this.user.phone,
      email: this.user.email,
      alternate_email: this.user.alternate_email,
    };
  },

  methods: {
    ...mapActions({
      update: "auth/updateProfile",
    }),

    save() {
      if (this.busy) {
        return;
      }
      this.busy = true;

      this.update(this.form)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Upload successful!",
            text: "Your Profile updated successfully.",
          });
        })
        .catch((error) => {
          if (error.response?.status === 422) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
